'use client';

import { Loader } from '@/components/loader';
import { useAuthStore } from '@/store/auth';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

interface AuthGuardProps {
  children: React.ReactNode;
}

const PROFILE_SETUP_PATH = '/profile-setup';

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const isHydrated = useAuthStore((state) => state.isHydrated);

  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (!isHydrated) return;

    // User is logged in but profile is NOT completed
    if (token && !user?.userName && pathname !== PROFILE_SETUP_PATH) {
      router.replace(PROFILE_SETUP_PATH);
    }
  }, [token, user, isHydrated, pathname, router]);

  // Wait for store hydration
  if (!isHydrated) {
    return <Loader />;
  }

  // While redirecting logged-in but incomplete users
  if (token && !user?.userName && pathname !== PROFILE_SETUP_PATH) {
    return <Loader />;
  }

  // ALLOWED when
  // Not logged in
  // Logged in + profile complete
  // Logged in + on profile setup page
  return <>{children}</>;
};
